<template>
  <div class="breadcrumb">
    <router-link
      :to="{ name: 'home' }"
      title="Retour à la page d'accueil"
    >
      Accueil
    </router-link>
    <component
      v-for="(route, key) in matchedRoutes"
      :key="key"
      :to="{ name: route.name }"
      :is="key !== Object.keys(matchedRoutes).length-1?'router-link':'span'"
    >
      {{ route.meta.breadcrumb }}
    </component>
  </div>
</template>

<script>
export default {
  name: 'Breadcrumbs',

  data () {
    return {
      matchedRoutes: []
    }
  },

  created () {
    this.matchedRoutes = this.$route.matched.filter(route => route.meta && route.meta.breadcrumb)
  }
}
</script>
